import { getUsersId } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { useQuery } from "@tanstack/react-query";

export const USER_DETAIL = "USER_DETAIL";

export function useUserDetail(userId?: number) {
	return useQuery({
		queryKey: [USER_DETAIL, userId],
		queryFn: processResponse(() => getUsersId(userId!)),
		retry: false,
		refetchInterval: false,
		refetchIntervalInBackground: false,
		throwOnError: true,
		enabled: !!userId,
	});
}
